<template>
  <div class="cooperation-add-wrapper global-card">
    <bread-crumb />
    <business-search
      v-if="!$route.query.id"
      :search-value="searchValue"
      :is-open="isOpen"
      :select-data="selectData"
      :info-loading="infoLoading"
      @onSearch="onSearch"
      @onChange="onChange"
      @handleSelect="handleSelect"
    />
	<div class="org-mseeage-wrapper" style="margin-bottom: 20px;">
		<a-card :bordered="false" style="width: 100%;border-radius:10px;position:relative;">
			<div class="title">
				工商信息
			</div>
			<a-spin v-if="detailsLoading" style="margin:auto;position:absolute;left:50%;top:50%;" />
			<div class="">
				<el-descriptions :column='2'>
					<el-descriptions-item label="统一社会信用代码">{{orgInfo.qichacha_credit_code||'-'}}</el-descriptions-item>
					<el-descriptions-item label="企业名称">{{orgInfo.qichacha_name||'-'}}</el-descriptions-item>
					<el-descriptions-item label="法定代表人">{{orgInfo.qichacha_oper_name||'-'}}</el-descriptions-item>
					<el-descriptions-item label="企业类型">{{orgInfo.qichacha_econ_kind||'-'}}</el-descriptions-item>
					<el-descriptions-item label="登记状态">{{orgInfo.qichacha_status||'-'}}</el-descriptions-item>
					<el-descriptions-item label="成立日期">{{orgInfo.qichacha_start_date||'-'}}</el-descriptions-item>
					<el-descriptions-item label="注册资本">{{orgInfo.qichacha_regist_capi||'-'}}</el-descriptions-item>
					<el-descriptions-item label="注册地址">{{orgInfo.qichacha_address||'-'}}</el-descriptions-item>
				</el-descriptions>
				<el-descriptions :column='1'>
					<el-descriptions-item label="经营范围">{{orgInfo.qichacha_scope}}</el-descriptions-item>
				</el-descriptions>
			</div>
		</a-card>
	</div>
    <!-- <div class="org-mseeage-wrapper">
      <a-card
        :bordered="false"
        style="width: 100%;border-radius:10px;position:relative;"
      >
        <div class="title">
          机构信息
        </div>
        <a-spin
          v-if="detailsLoading"
          style="margin:auto;position:absolute;left:50%;top:50%;"
        />
        <div class="orginfo-wrapper">
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                公司名称
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_name }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                公司性质
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_econ_kind }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                注册资金/万
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_regist_capi }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                法人代表
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_oper_name }}
              </p>
            </div>
          </div>
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                社会统一信用代码
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_credit_code }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                经营状态
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_status }}
              </p>
            </div>
            <div class="flex-item-content">
              <p
                class="flex-item-left"
                style="text-align:left"
              >
                注册时间
              </p>
              <p
                class="flex-item-right"
                style="text-align:right"
              >
                {{ orgInfo.qichacha_start_date }}
              </p>
            </div>
          </div>
          <div class="flex-item-wrapper business-scope-wrapper">
            <div class="business-scope-head">
              经营范围
            </div>
            <div class="business-scope-content">
              {{ orgInfo.qichacha_scope }}
            </div>
          </div>
        </div>
      </a-card>
    </div> -->

    <div class="form-card-wrapper">
      <a-card
        :bordered="false"
        style="width: 100%;border-radius:10px;"
      >
        <form-card
          ref="formcard1"
          title="机构详情"
          :form-data="formData1"
          class="class1"
        >
          <template #website>
            <a-input
              v-decorator="['website', { initialValue: data1.website }]"
              placeholder="请输入企业网址"
            />
          </template>
          <template #taxscale>
            <a-select
              v-decorator="[
                'taxscale',
                {
                  rules: [{ required: true, message: '请选择纳税规模' }],
                  initialValue: data1.taxscale,
                },
              ]"
            >
              <a-select-option
                v-for="item in taxscaleData"
                :key="item.key"
                :value="item.key"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template #contact>
            <contact-info
              v-decorator="[
                'contact',
                {
                  rules: [{ required: true, validator: checkBussinessContact }],
                  initialValue: data1.contact,
                },
              ]"
            />
          </template>
          <template #nature>
            <a-select
              v-decorator="[
                'nature',
                {
                  rules: [{ required: true, message: '请选择行业性质' }],
                  initialValue: data1.nature,
                },
              ]"
            >
              <a-select-option
                v-for="item in natureData"
                :key="item.key"
                :value="item.key"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template #provinceCity>
            <province-city
              v-decorator="[
                'provinceCity',
                {
                  rules: [{ required: true, validator: checkProvinceCity }],
                  initialValue: data1.provinceCity,
                },
              ]"
            />
          </template>
          <template #corporation>
            <a-input
              v-decorator="[
                'corporation',
                {
                  rules: [
                    {
                      required: true,
                      pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                      message: '请输入正确的法人身份证',
                    },
                  ],
                  initialValue: data1.corporation,
                },
              ]"
              placeholder="请输入法人身份证"
            />
          </template>
          <template #location>
            <a-textarea
              v-decorator="['location', { initialValue: data1.location }]"
              rows="3"
              placeholder="请输入企业详细地址"
              style="resize:none;"
            />
          </template>
        </form-card>
        <form-card
          ref="formcard2"
          title="账户信息"
          :form-data="formData2"
        >
          <template #bankname>
            <a-input
              v-decorator="[
                'bankname',
                {
                  rules: [{ required: true, message: '请输入开户行' }],
                  initialValue: data2.bankname,
                },
              ]"
              placeholder="请输入开户行"
            />
          </template>
          <template #banksubname>
            <a-input
              v-decorator="[
                'banksubname',
                {
                  rules: [{ required: true, message: '请输入开户支行' }],
                  initialValue: data2.banksubname,
                },
              ]"
              placeholder="请输入开户支行"
            />
          </template>
          <template #banknum>
            <a-input
              v-decorator="[
                'banknum',
                {
                  rules: [{ required: true, message: '请输入银行账号' }],
                  initialValue: data2.banknum,
                },
              ]"
              placeholder="请输入银行账号"
            />
          </template>
          <template #bankaccount>
            <a-input
              v-decorator="[
                'bankaccount',
                {
                  rules: [{ required: true, message: '请输入账户名称' }],
                  initialValue: data2.bankaccount,
                },
              ]"
              placeholder="请输入账户名称"
            />
          </template>
          <template #invoicetitle>
            <a-input
              v-decorator="[
                'invoicetitle',
                {
                  rules: [{ required: true, message: '请输入发票开头' }],
                  initialValue: data2.invoicetitle,
                },
              ]"
              placeholder="请输入发票开头"
            />
          </template>
          <template #taxidnum>
            <a-input
              v-decorator="[
                'taxidnum',
                {
                  rules: [{ required: true, message: '请输入纳税人识别号' }],
                  initialValue: data2.taxidnum,
                },
              ]"
              placeholder="请输入纳税人识别号"
            />
          </template>
          <template #invoicetype>
            <a-radio-group
              v-decorator="[
                'invoicetype',
                {
                  rules: [{ required: true,message:'请选择发票类型' }],
                  initialValue: data2.invoicetype || 0,
                },
              ]"
            >
              <a-radio
                v-for="item in invoiceData"
                :key="item.key"
                :value="item.key"
              >
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </template>
        </form-card>
        <form-card
          ref="formcard3"
          title="收件人信息"
          :form-data="formData3"
        >
          <template #consignee>
            <a-input
              v-decorator="[
                'consignee',
                {
                  rules: [{ required: true, message: '请输入收件人姓名' }],
                  initialValue: data3.consignee,
                },
              ]"
              placeholder="请输入收件人姓名"
            />
          </template>
          <template #shipaddress>
            <a-input
              v-decorator="[
                'shipaddress',
                {
                  rules: [{ required: true, message: '请输入收件地址' }],
                  initialValue: data3.shipaddress,
                },
              ]"
              placeholder="请输入收件地址"
            />
          </template>
          <template #consigneephone>
            <a-input
              v-decorator="[
                'consigneephone',
                {
                  rules: [
                    { required: true, message: '请输入手机号码' },
                    {
                      pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                      message: '请输入正确的手机号码',
                    },
                  ],
                  initialValue: data3.consigneephone,
                },
              ]"
              placeholder="请输入手机号码"
            />
          </template>
          <template #zipcode>
            <a-input
              v-decorator="[
                'zipcode',
                {
                  rules: [
                    { required: true, message: '请输入邮政编码' },
                    {
                      pattern: /^[0-9]{6}$/,
                      message: '格式错误',
                    },
                  ],
                  initialValue: data3.zipcode,
                },
              ]"
              placeholder="请输入邮政编码"
            />
          </template>
        </form-card>
        <form-card
          ref="formcard5"
          title="印章图片"
          :form-data="formData5"
        >
          <template #sign_img>
            <a-upload
              v-decorator="[
                'sign_img',
                {
                  rules: [{ required: true, message: '请上传印章图片' }],
                  initialValue: data5.sign_img,
                },
              ]"
              accept=".png,.gif"

              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg7"
            >
              <a-spin :spinning="spinning7">
                <div
                  v-if="imageUrl7"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl7"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
        </form-card>
        <form-card
          ref="formcard6"
          title="企业信息"
          :form-data="formData6"
        >
          <template #icon>
            <a-upload
              v-decorator="[
                'icon',
                {
                  rules: [{ required: true, message: '请上传图片' }],
                  initialValue: data6.icon,
                },
              ]"
              accept=".jpg,.png,.jpeg,.gif"

              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg8"
            >
              <a-spin :spinning="spinning8">
                <div
                  v-if="imageUrl8"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl8"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
          <template #desc>
            <a-textarea
              v-decorator="[
                'desc',
                {
                  rules: [{ required: true, message: '请输入企业描述' }],
                  initialValue: data6.desc,
                },
              ]"
              :row="2"
            />
          </template>
        </form-card>
        <form-card
          ref="formcard4"
          title="证据文件"
          :form-data="formData4"
          :gutter="24"
          layout="vertical"
          class="form-card-upload"
        >
          <template #blImg>
            <span class="upload-title">大小限10mb以内</span>
            <a-upload
              v-decorator="[
                'blImg',
                {
                  rules: [{ required: true, message: '请上传营业执照照片' }],
                  initialValue: data4.blImg,
                },
              ]"
              accept=".jpg,.gif,.png,.jpeg"
              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg1"
            >
              <a-spin :spinning="spinning1">
                <div
                  v-if="imageUrl1"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl1"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
          <template #operimgfront>
            <span class="upload-title">大小限10mb以内</span>
            <a-upload
              v-decorator="[
                'operimgfront',
                {
                  rules: [
                    { required: true, message: '请上传法人身份证正面照' },
                  ],
                  initialValue: data4.operimgfront,
                },
              ]"
              accept=".jpg,.gif,.png,.jpeg"
              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg2"
            >
              <a-spin :spinning="spinning2">
                <div
                  v-if="imageUrl2"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl2"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
          <template #operimgbackend>
            <span class="upload-title">大小限10mb以内</span>
            <a-upload
              v-decorator="[
                'operimgbackend',
                {
                  rules: [
                    { required: true, message: '请上传法人身份证反面照' },
                  ],
                  initialValue: data4.operimgbackend,
                },
              ]"
              accept=".jpg,.gif,.png,.jpeg"
              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg3"
            >
              <a-spin :spinning="spinning3">
                <div
                  v-if="imageUrl3"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl3"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
          <template #bankopeningimg>
            <span class="upload-title">大小限10mb以内</span>
            <a-upload
              v-decorator="[
                'bankopeningimg',
                { initialValue: data4.bankopeningimg },
              ]"
              accept=".jpg,.gif,.png,.jpeg"
              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg4"
            >
              <a-spin :spinning="spinning4">
                <div
                  v-if="imageUrl4"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl4"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
          <template #leaseimgs>
            <span class="upload-title">大小限10mb以内</span>
            <a-upload
              v-decorator="['leaseimgs', { initialValue: data4.leaseimgs }]"
              accept=".jpg,.gif,.png,.jpeg"
              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg5"
            >
              <a-spin :spinning="spinning5">
                <div
                  v-if="imageUrl5"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl5"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
          <template #otherimgs>
            <span class="upload-title">大小限10mb以内</span>
            <a-upload
              v-decorator="['otherimgs', { initialValue: data4.otherimgs }]"
              accept=".jpg,.gif,.png,.jpeg"
              :action="`${uploadUrl}system/upload`"
              list-type="picture-card"
              :show-upload-list="false"
              name="upload"
              :data="{ fileType: 'img',token }"
              :before-upload="beforeUpload"
              @change="handleChangeImg6"
            >
              <a-spin :spinning="spinning6">
                <div
                  v-if="imageUrl6"
                  style="width:282px;height:180px;"
                >
                  <img
                    :src="imageUrl6"
                    alt="avatar"
                    width="100%"
                    height="100%"
                  >
                </div>
                <div v-else>
                  <div class="ant-upload-text">
                    点击上传
                  </div>
                </div>
              </a-spin>
            </a-upload>
          </template>
        </form-card>
        <form-button
          :btn-is-loading="btnIsLoading"
          class="form-card-button"
          @onCancel="onCancel"
          @onSubmit="onSubmit"
        />
      </a-card>
    </div>
  </div>
</template>
<script>
import { formData1, formData2, formData3, formData4, formData5, formData6 } from './../data';
import ContactInfo from './../components/ContactInfor';
import ProvinceCity from './../../BusinessManage/components/ProvinceCity';
import BusinessSearch from './../components/BusinessSearch';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  components: { ContactInfo, ProvinceCity, BusinessSearch },
  data() {
    return {
      btnIsLoading: false,
      searchValue: '',
      infoLoading: false,
      isOpen: false,
      selectData: [],
      orgInfo: {},
      formData1,
      taxscaleData: [],
      natureData: [],
      invoiceData: [],
      invoiceDefault: '',
      formData2,
      formData3,
      formData4,
      formData5,
      formData6,
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      spinning1: false,
      spinning2: false,
      spinning3: false,
      spinning4: false,
      spinning5: false,
      spinning6: false,
      spinning7: false,
      spinning8: false,
      imageUrl1: '',
      imageUrl2: '',
      imageUrl3: '',
      imageUrl4: '',
      imageUrl5: '',
      imageUrl6: '',
      imageUrl7: '',
      imageUrl8: '',
      keyNo: '',
      detailsLoading: false,
      token: '',
    };
  },
  created() {
    this.token=localStorage.getItem('token');
    // 获取 纳税规模、行业性质、发票类型
    this.getSystemInfo();
    // 编辑/获取企业信息
    if (this.$route.query.id) {
      this.getEdit();
    }
  },
  methods: {
    // 回显获取企业信息
    async getEdit() {
      const id = this.$route.query.id;
      let result = await this.$http.post('/ServiceProvider/getCompanyInfo', {
        id,
      });
      if (result.data.status === 1) {
        let data = result.data.data.companyInfo;
        this.keyNo = data.qichacha_key_no;
        this.orgInfo = data;
        this.data1 = {
          website: data.website,
          taxscale: data.tax_scale,
          contact: { phone: data.phone, email: data.email },
          nature: data.nature_of_industry,
          provinceCity: { province: data.province, city: data.city },
          corporation: data.id_card_of_oper,
          location: data.location,
        };

        this.data2 = {
          bankname: data.bank_name,
          banksubname: data.bank_sub_name,
          banknum: data.bank_num,
          bankaccount: data.bank_account,
          invoicetitle: data.invoice_title,
          taxidnum: data.tax_id_num,
          invoicetype: data.invoice_type,
        };
        this.data3 = {
          consignee: data.consignee,
          shipaddress: data.ship_address,
          consigneephone: data.consignee_phone,
          zipcode: data.zip_code,
        };
        this.data4 = {
          blImg: data.bl_img.id,
          operimgfront: data.oper_id_img_front.id,
          operimgbackend: data.oper_id_img_backend.id,
          bankopeningimg: data.bank_opening_permit_img.id
            ? data.bank_opening_permit_img.id
            : '',
          leaseimgs: data.lease_evidence_imgs.id
            ? Number(data.lease_evidence_imgs.id)
            : '',
          otherimgs: data.other_doc_evidence_imgs.id
            ? Number(data.other_doc_evidence_imgs.id)
            : '',
        };
        this.data5={
          sign_img: data.sign_img?data.sign_img.id:'',
        };
        this.data6={
          icon: result.data.data.icon?result.data.data.icon:'',
          desc: result.data.data.desc,
        };
        console.log(this.data4);
        this.imageUrl1 = data.bl_img.url;
        this.imageUrl2 = data.oper_id_img_front.url;
        this.imageUrl3 = data.oper_id_img_backend.url;
        this.imageUrl4 = data.bank_opening_permit_img.url
          ? data.bank_opening_permit_img.url
          : '';
        this.imageUrl5 = data.lease_evidence_imgs.url
          ? data.lease_evidence_imgs.url
          : '';
        this.imageUrl6 = data.other_doc_evidence_imgs.url
          ? data.other_doc_evidence_imgs.url
          : '';
        this.imageUrl7 = data.sign_img.url;
        this.imageUrl8 = result.data.data.icon_url;
      }
    },
    // 获取 纳税规模、行业性质、发票类型
    async getSystemInfo() {
      let result = await this.$http.post('/system/getConfigs');
      if (result.data.status === 1) {
        this.taxscaleData = result.data.data.tax_scale;
        this.natureData = result.data.data.nature_of_industry;
        this.invoiceData = result.data.data.invoice_type;
        this.invoiceDefault = this.invoiceData[0].key;
      }
    },
    // input change事件
    onChange(value) {
      this.searchValue = value;
    },
    // 搜索按钮
    async onSearch() {
      this.infoLoading = true;
      this.isOpen = true;
      let result = await this.$http.post('/company/getCompanyInfoList', {
        keyword: this.searchValue,
      });
      if (result.data.status === 1) {
        this.infoLoading = false;
        this.selectData = result.data.data.data_list;
      }
    },
    // select 获取详细信息
    async handleSelect(value) {
      this.searchValue = value.qichacha_name;
      this.isOpen = false;
      this.detailsLoading = true;
      let result = await this.$http.post('/company/getCompanyInfoDetail', {
        id: value.id,
      });
      if (result.data.status === 1) {
        this.orgInfo = result.data.data;
        this.keyNo = result.data.data.qichacha_key_no;
        this.detailsLoading = false;
      }
    },

    // 上传图片
    handleChangeImg1(info) {
      this.spinning1 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning1 = false;
          this.isImage1 = true;
          this.imageUrl1 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning1 = false;
      }
    },

    // 上传图片
    handleChangeImg2(info) {
      this.spinning2 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning2 = false;
          this.imageUrl2 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning2 = false;
      }
    },
    // 上传图片
    handleChangeImg3(info) {
      this.spinning3 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning3 = false;
          this.imageUrl3 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning3 = false;
      }
    },

    // 上传图片
    handleChangeImg4(info) {
      this.spinning4 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning4 = false;
          this.imageUrl4 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning4 = false;
      }
    },
    // 上传图片
    handleChangeImg5(info) {
      this.spinning5 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning5 = false;
          this.imageUrl5 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning5 = false;
      }
    },

    // 上传图片
    handleChangeImg6(info) {
      this.spinning6 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning6 = false;
          this.imageUrl6 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning6 = false;
      }
    },
    // 签章图片
    handleChangeImg7(info) {
      this.spinning7 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning7 = false;
          this.imageUrl7 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning7 = false;
      }
    },
    // 企业信息  图片
    handleChangeImg8(info) {
      this.spinning8 = true;
      if (info.file.status === 'uploading') {
        return;
      }
      if (info.file.response.status === 1) {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.spinning8 = false;
          this.imageUrl8 = imageUrl;
        });
      } else {
        this.$message.warning(info.file.response.msg);
        this.spinning8 = false;
      }
    },
    // 上传之前校验10M
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('图片大小不得超过10M!');
      }
      return isLt10M;
    },

    // 确定新建或修改
    async onSubmit() {
      let datas = {};
      let form1 = false;
      let form2 = false;
      let form3 = false;
      let form4 = false;
      let form5=false;
      let form6=false;
      this.$refs.formcard1.form.validateFields((err, values) => {
        if (!err) {
          datas = Object.assign({}, values);
          form1 = true;
        }
      });
      this.$refs.formcard2.form.validateFields((err, values) => {
        if (!err) {
          datas = Object.assign({}, datas, values);
          form2 = true;
        }
      });
      this.$refs.formcard3.form.validateFields((err, values) => {
        if (!err) {
          datas = Object.assign({}, datas, values);
          form3 = true;
        }
      });
      this.$refs.formcard4.form.validateFields((err, values) => {
        if (!err) {
          datas = Object.assign({}, datas, values);
          form4 = true;
        }
      });
      this.$refs.formcard5.form.validateFields((err, values) => {
        if (!err) {
          datas = Object.assign({}, datas, values);
          form5 = true;
        }
      });
      this.$refs.formcard6.form.validateFields((err, values) => {
        if (!err) {
          datas = Object.assign({}, datas, values);
          form6 = true;
        }
      });
      if (form1 & form2 & form3 & form4 &form5&form6) {
        this.btnIsLoading=true;
        let key_no = { key_no: this.keyNo };
        let data = {
          website: datas.website,
          tax_scale: datas.taxscale,
          phone: datas.contact.phone,
          email: datas.contact.email,
          nature_of_industry: datas.nature,
          province: datas.provinceCity.province,
          city: datas.provinceCity.city,
          location_path: `0,${datas.provinceCity.province},${datas.provinceCity.city},`,
          id_card_of_oper: datas.corporation,
          location: datas.location,

          bank_name: datas.bankname,
          bank_sub_name: datas.banksubname,
          bank_num: datas.banknum,
          bank_account: datas.bankaccount,
          invoice_title: datas.invoicetitle,
          tax_id_num: datas.taxidnum,
          invoice_type: datas.invoicetype,

          consignee: datas.consignee,
          ship_address: datas.shipaddress,
          consignee_phone: datas.consigneephone,
          zip_code: datas.zipcode,

          sign_img: datas.sign_img.file?datas.sign_img.file.response.data.id
            : datas.sign_img,

          bl_img: datas.blImg.file
            ? datas.blImg.file.response.data.id
            : datas.blImg,
          oper_id_img_front: datas.operimgfront.file
            ? datas.operimgfront.file.response.data.id
            : datas.operimgfront,
          oper_id_img_backend: datas.operimgbackend.file
            ? datas.operimgbackend.file.response.data.id
            : datas.operimgbackend,
          bank_opening_permit_img: datas.bankopeningimg&&datas.operimgfront.file
            ? datas.bankopeningimg.file.response.data.id
            : undefined,
          lease_evidence_imgs: datas.leaseimgs&&datas.operimgfront.file
            ? datas.leaseimgs.file.response.data.id
            : undefined,
          other_doc_evidence_imgs: datas.otherimgs&&datas.operimgfront.file
            ? datas.otherimgs.file.response.data.id
            : undefined,


          icon: datas.icon.file
            ? datas.icon.file.response.data.id
            : datas.icon,
          desc: datas.desc,
        };

        let result = await this.$http.post('/ServiceProvider/update', {
          ...key_no,
          ...data,
        });
        this.btnIsLoading=false;
        if (result.data.status === 1) {
          this.$message.success('操作成功！');
          this.$router.back();
        }
      }
    },
    // 取消新建或修改
    onCancel() {
      this.$router.back();
    },
    // 自定义企业电话  邮箱验证
    checkBussinessContact(rule, value, callback) {
      if (value === undefined) {
        return callback('请输入电话和邮箱！');
      }
      const error = [];
      if (!value.phone) {
        error.push('联系方式');
      }
      if (!value.email) {
        error.push('邮箱');
      }
      if (error.length === 0) {
        callback();
        return;
      }
      callback(`请输入${error.join('和')}`);
    },
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      const error = [];
      if (!value || !value.province) {
        error.push('省份');
      }
      if (!value || !value.city) {
        error.push('城市');
      }
      if (error.length === 0) {
        callback();
      }
      callback(`请选择${error.join('和')}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.cooperation-add-wrapper {
  margin-bottom: 40px;
  .business-scope-wrapper {
    .business-scope-head {
      margin-top: -35px;
      font-size: 16px;
    }
    .business-scope-content {
      background: rgba(249, 249, 252, 1);
      border-radius: 10px;
      padding: 20px;
      margin: 20px 10px;
      min-height: 100px;
    }
  }
  .form-card-wrapper {
    margin-top: 20px;
    .ant-card-body {
      display: block;
      padding-bottom: 0;
    }
  }
  .form-card-upload {
    .upload-title {
      position: relative;
      top: -9px;
      right: -191px;
      color: #c3c7d5;
      font-size: 12px;
    }
    .ant-upload-text {
      color: #d6daea;
      margin-top: 50px;
    }
  }
  .form-card-button {
    background: #f9f9fc;
    margin: 0 -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
</style>
